
export enum CommandType {
    Insert,
    Replace,
    Delete
}

export enum CommandSendType {
    ClientCommand,
    ServerCommand
}
